import { render, staticRenderFns } from "./list-batch.vue?vue&type=template&id=239e873c&"
import script from "./list-batch.vue?vue&type=script&lang=js&"
export * from "./list-batch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports